let generation = 0;

/** Record user activity that may create transient DOM state (open menus,
 * dialogs, focus, or selection). Background workspace
 * responses that started before this activity must not replace that DOM. */
export function markInteraction(): void {
  generation += 1;
}

/** Capture the current interaction generation at the start of an async read. */
export function interactionGeneration(): number {
  return generation;
}

/** An open Kerf menu (its trigger reports `aria-expanded`), an open Kerf Select,
 * or an open dialog (Kerf beta 106 draws its own menus and selects). */
export const TRANSIENT_OPEN_SELECTOR =
  '.kui-popup-menu__trigger[aria-expanded="true"], kui-select[open], dialog[data-component="dialog-surface"][open]';

/** True while replacing the workspace would visibly destroy transient UI.
 * The DOM check complements the generation check: it covers a refresh that
 * starts after a menu or dialog is already active. */
export function transientInteractionOpen(): boolean {
  return typeof document !== 'undefined' && document.querySelector(TRANSIENT_OPEN_SELECTOR) !== null;
}
